// src/js-dot/ui/animate/spacer.ts
import { $remove, $tag } from "@js-dot/ui";

// src/js-dot/ui/animate/after-animate$.ts
function afterAnimate$(node, className) {
  return new Promise(resolve => {
    node.onanimationend = () => {
      resolve();
    };
    node.classList.add(className);
    const computedStyle = getComputedStyle(node);
    if (computedStyle["animationName"] === "none" || computedStyle["animationDuration"] == "0") {
      resolve();
    }
  });
}

// src/js-dot/ui/animate/spacer.ts
import { keyframes, Styles } from "@js-dot/ui/style";
function getSpacer(node) {
  const styles = new Styles();
  const emptySpace = {
    width: 0,
    height: 0
  };
  styles.add({
    __ADD_SPACE: keyframes({
      from: emptySpace
    }),
    __REMOVE_SPACE: keyframes({
      to: emptySpace
    }),
    ".__add_space": {
      animationName: "__ADD_SPACE",
      animationDuration: "0.12s"
    },
    ".__remove_space": {
      animationName: "__REMOVE_SPACE",
      animationDuration: "0.12s"
    }
  });
  return (getSpacer = function (node2) {
    const sizer = $tag("div", {
      style: {
        width: node2.offsetWidth + "px",
        height: node2.offsetHeight + "px"
      }
    });
    node2.parentNode.insertBefore(sizer, node2.nextSibling);
    return sizer;
  }).apply(this, arguments);
}
function addSpace$(node) {
  const spacer = getSpacer(node);
  node.style.display = "none";
  return afterAnimate$(spacer, "__add_space").then(() => {
    $remove(spacer);
    node.style.display = "inherit";
  });
}
function removeSpace$(node) {
  const spacer = getSpacer(node);
  $remove(node);
  return afterAnimate$(spacer, "__remove_space").then(() => {
    return $remove(spacer);
  });
}
function addSpace(node) {
  addSpace$(node).then();
}
function removeSpace(node) {
  removeSpace$(node).then();
}

// src/js-dot/ui/animate/close-animate$.ts
function closeAnimate$(node) {
  return afterAnimate$(node, "_close");
}
export { addSpace, addSpace$, afterAnimate$, closeAnimate$, removeSpace, removeSpace$ };
